const columnsAllCustomer = [
  {
    key: "no",
    title: "#",
    scopedSlots: { customRender: "no" },
    width: 70,
  },

  {
    key: "price",
    title: "Price",
    dataIndex: "price",
    scopedSlots: { customRender: "price" },
  },
  {
    key: "model",
    title: "Name",
    dataIndex: "model",
  },
  {
    title: "Created at",
    key: "createdAt",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
  },
  {
    title: "Updated at",
    key: "updatedAt",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
  },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
    fixed: "right",
  },
];

export { columnsAllCustomer };
